// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/border.css'
import './assets/css/reset.css'
import Vant from 'vant'
import 'vant/lib/index.css';
import { Lazyload, SwipeCell } from 'vant';
import Vuex from 'vuex'
import store from './store/index'
import axios from 'axios'
import clipboard from 'clipboard';
import VueAxios from 'vue-axios'
import VideoPlayer from 'vue-video-player'
import {commonPost, post, fetch, patch, put} from './assets/js/httpRequestUtil'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();
//定义全局变量
Vue.prototype.uplaodServer = 'haweiyun'; // aliyun 阿里云  haweiyun华为云
Vue.prototype.cdnImgPath = 'https://ymrjimages.kjyoumi.com'; // CDN图片地址
Vue.prototype.imgCrop = '?x-image-process=image/'; // 阿里云 ?x-oss-process=image/ 华为云 ?x-image-process=image/
Vue.prototype.phoneType = false; // 手机开关
Vue.prototype.appType = '1';
Vue.prototype.appId = 'wx9db66a9bb1c10a5f';
Vue.prototype.showAliPay = true;
Vue.prototype.showUnionWeChatPay = false;
Vue.prototype.$commonPost = commonPost
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$clipboard = clipboard;
Vue.use(VueAxios, axios);
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Vuex);
Vue.use(SwipeCell);
Vue.use(VideoPlayer);
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
];// 忽略自定义元素标签抛出的报错
Vue.config.productionTip = false
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?8841f0580e80d306215766cd376185a4";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
router.beforeEach((to, from, next) => {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', to.fullPath]);
    }
  }
  if(to.path == '/payMask' || to.path == '/payResult'|| to.path == '/turn'|| to.path =='/signResult' || to.path =='/authResult' || to.path == '/iframe' || to.path == '/fingerpostDetail'){
    next()
    return false
  }
  if(!(store.state.userInfo && store.state.userInfo.nbr) && to.path != '/login'){
    // 第一次进入项目
    localStorage.setItem('beforeLoginUrl', to.fullPath)// 保存用户进入的url
    next({path:'/login',replace:true})
    return false
  }
  if(to.path=='/login' && store.state.userInfo && store.state.userInfo.nbr){
    next({path:'/index',query:{supNbr:store.state.userInfo.nbr}})
    return false
  }
  next()
})
router.afterEach((to,from) => {
  if (!!window.__wxjs_is_wkwebview) {  // IOS
    if (window.entryUrl == '' || window.entryUrl == undefined) {
      var url = `${location.origin}${to.fullPath}`
      window.entryUrl = url;    // 将后面的参数去除
    }
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js